import actionTypes from "../../actions/actionTypes";

const initialState = {
  queryData: [],
  queryDataSupport: [],
  putQueryData: [],
};

const myQueryReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.myQueries.GET_ALL_ASSIGNED_QUERIES:
      return {
        ...state,
        queryData: payload,
      };

    case actionTypes.adminTypes.myQueries.GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB:
      return {
        ...state,
        queryDataSupport: payload,
      };
    case actionTypes.adminTypes.myQueries.PUT_QUERY:
      return {
        ...state,
        putQueryData: payload,
      };
      default:
      return state;
  }
};

export default myQueryReducer;
